<template>
  <div class="app-home">
    <HeaderLayout></HeaderLayout>

    <div class="app-home-table">
      <div class="table-name">
        <span>{{dataType}} {{ labelText("list") }}</span>
        <el-button type="primary" @click="handleCoaClick">
          <template>
            <i class="el-icon-plus"></i>
            <span>COA</span>
          </template>
        </el-button>
        <el-button type="primary" @click="handleFileClick">
          <template>
            <i class="el-icon-document"></i>
            <span>Library</span>
          </template>
        </el-button>
        <el-button type="warning" @click="handleVerifyListClick" v-if="!getAuthShow()">
          <template>
            <span>Verify List</span>
          </template>
        </el-button>
        <el-button
          type="primary"
          v-if="getNewShow()"
          @click="addClick"
        >
          <template>
            <i class="el-icon-plus"></i>
            <span>New</span>
          </template>
        </el-button>
      </div>

      <!-- 搜索栏 -->
      <el-row style="padding: 10px">
        <el-col :span="6">
          <span>{{ labelText("product_name") }}：</span>
          <el-autocomplete
            clearable
            v-model="searchParams.productName"
            :fetch-suggestions="productNameSuggestionsSearch"
            :placeholder="labelText('please_input')"
            popper-class="select-option"
            :popper-append-to-body="false"
          ></el-autocomplete>
        </el-col>
        <el-col :span="6">
          <div>
            <span>{{ labelText("item_code") }}：</span>
            <el-autocomplete
              popper-class="select-option"
              :popper-append-to-body="false"
              clearable
              v-model="searchParams.itemCode"
              :fetch-suggestions="itemCodeSuggestionsSearch"
              :placeholder="labelText('please_input')"
            ></el-autocomplete>
          </div>
        </el-col>
        <el-col :span="9">
          <div style="margin-right: 20px">
            <el-radio-group
              v-model="dataType"
              size="medium"
              @change="dataTypeChange"
            >
              <el-radio-button label="Spec"></el-radio-button>
              <el-radio-button label="SDS"></el-radio-button>
              <el-radio-button label="Composition"></el-radio-button>
              <el-radio-button label="TPS"></el-radio-button>
              <el-radio-button label="Conversion"></el-radio-button>
              <el-radio-button label="TDS"></el-radio-button>
              <el-radio-button label="Test Method"></el-radio-button>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="3">
          <div>
            <el-button @click="handleSearch()" type="primary">Search</el-button>
            <el-button @click="resetHandle()">Reset</el-button>
          </div>
        </el-col>
      </el-row>

      <SpecList v-if="dataType == 'Spec'" ref="specListRef"></SpecList>
      <SdsList v-if="dataType == 'SDS'" ref="sdsListRef"></SdsList>
    </div>
  </div>
</template>

<script>
import HeaderLayout from "@/views/Home/layout/HeaderLayout.vue";
import SpecList from "./spec/Spec-List.vue";
import SdsList from "./sds/SdsList.vue";
import * as mappingUtils from "./spec/config/sdsMapping";
import * as keyConvertUtils from "./spec/config/jsonKeyConverter";
import base from "@/common/base.js";
// import VerifyList from "../../VerifyList.vue";

export default {
  components: {
    HeaderLayout,
    SpecList,
    SdsList,
  },
  data() {
    return {
      language: "EN",
      dataType: "Spec",
      // 查询条件
      searchParams: {
        productName: "",
        itemCode: "",
      },
      // itemCode 列表数据
      itemCodeList: [],
    };
  },
  computed: {
    // 用户信息
    username() {
      let userInfo = JSON.parse(localStorage.getItem("specUserInfo"));
      localStorage.setItem("loginUserNameKey", userInfo.username);
      if (userInfo) {
        return userInfo.username;
      } else {
        return "";
      }
    },
    labelText() {
      // 获取标签文本
      return function (text) {
        if (this.language === "EN") {
          return keyConvertUtils.convertToTitleCase(text);
        }
        return mappingUtils.getValueByKey(text);
      };
    },
  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      if (to.query.type && to.query.type !== from.query.type) {
        this.handleTypeChange(to.query.type);
      }
    }
  },
  created() {
    // 处理语言参数
    let pathLanguage = 'EN';
    if(this.$route.query.language && typeof(this.$route.query.language) !== 'undefined'){
      this.language = this.$route.query.language;
      pathLanguage = this.$route.query.language;
    }
    localStorage.setItem('language', pathLanguage)
    
    // 处理type参数，优先从URL参数获取
    if (this.$route.query.type && typeof(this.$route.query.type) !== 'undefined') {
      // 将URL参数的type转换为正确的dataType格式
      let urlType = this.$route.query.type.toLowerCase();
      if (urlType === 'spec') {
        this.dataType = 'Spec';
      } else if (urlType === 'sds') {
        this.dataType = 'SDS';
      } else if (urlType === 'composition') {
        this.dataType = 'Composition';
      } else if (urlType === 'tps') {
        this.dataType = 'TPS';
      } else if (urlType === 'conversion') {
        this.dataType = 'Conversion';
      } else if (urlType === 'tds') {
        this.dataType = 'TDS';
      } else if (urlType === 'test method') {
        this.dataType = 'Test Method';
      } else {
        // 如果URL参数不匹配，使用默认值
        this.dataType = 'Spec';
      }
      // 将选择的类型保存到localStorage
      localStorage.setItem("dataType", this.dataType);
    } else {
      // 如果URL中没有type参数，从localStorage获取
      let dType = localStorage.getItem("dataType");
      if (typeof dType !== "undefined" && dType !== null) {
        this.dataType = dType;
      }
    }
  },
  mounted() {
    this.getSpecItemCodeListData();
  },
  methods: {
    getNewShow(){
      let userInfo = JSON.parse(localStorage.getItem("specUserInfo"));
      return userInfo.roleId==2||userInfo.roleId==1||userInfo.roleId==4;
    },
    getAuthShow(){
      return base.getAuthShow();
    },
    getListType(){

    },
    // 处理type参数变化
    handleTypeChange(urlType) {
      if (!urlType) return;
      
      let newDataType = 'Spec'; // 默认值
      urlType = urlType.toLowerCase();
      
      if (urlType === 'spec') {
        newDataType = 'Spec';
      } else if (urlType === 'sds') {
        newDataType = 'SDS';
      } else if (urlType === 'composition') {
        newDataType = 'Composition';
      } else if (urlType === 'tps') {
        newDataType = 'TPS';
      } else if (urlType === 'conversion') {
        newDataType = 'Conversion';
      } else if (urlType === 'tds') {
        newDataType = 'TDS';
      } else if (urlType === 'test method') {
        newDataType = 'Test Method';
      }
      
      if (this.dataType !== newDataType) {
        this.dataType = newDataType;
        localStorage.setItem("dataType", this.dataType);
        this.getSpecItemCodeListData();
      }
    },
    addClick(){
      let currentType = this.dataType.toLocaleLowerCase()
      let language = localStorage.getItem("language");
      if (this.dataType.toLocaleLowerCase() == "sds") {
        this.$router.push({ path: "new-sds",query:{type:currentType, isCopy: false,language } });
      }else{
        this.$router.push({ path: "detail",query:{type:currentType, isCopy: false,language } });
      }
      
    },
    // 重置查询条件
    resetHandle() {
      this.searchParams.itemCode = "";
      this.searchParams.productName = "";
    },
    // productName搜索
    productNameSuggestionsSearch(queryString, cb) {
      let list = [];
      console.info("this.itemCodeList:", this.itemCodeList);
      this.itemCodeList.forEach((element) => {
        list.push({ value: element.productName });
      });
      let results = queryString
        ? list.filter(this.createFilter(queryString))
        : list;
      cb(results);
    },
    // 加载 itemCode 数据
    getSpecItemCodeListData(params) {
      let refKey = "";
      if (this.dataType === "Spec") {
        refKey = "specListRef";
      } else if (this.dataType === "SDS") {
        refKey = "sdsListRef";
      }
      
      // 尝试从 localStorage 加载数据
      const storedData = localStorage.getItem(`${this.dataType}_itemCodeList`);
      const storedTime = localStorage.getItem(`${this.dataType}_itemCodeList_time`);
      const currentTime = new Date().getTime();
      
      if (storedData && storedTime && (currentTime - storedTime < 7 * 24 * 60 * 60 * 1000)) {
        // 如果数据存在且未过期，直接使用存储的数据
        this.itemCodeList = JSON.parse(storedData);
      } else {
        // 否则从组件中获取数据
        const refComponent = this.$refs[refKey];
        if (
          refComponent &&
          typeof refComponent.getItemCodeListData === "function"
        ) {
          refComponent.getItemCodeListData(params, (data) => {
            this.itemCodeList = data;
            // 存储数据到 localStorage，并设置有效期
            localStorage.setItem(`${this.dataType}_itemCodeList`, JSON.stringify(data));
            localStorage.setItem(`${this.dataType}_itemCodeList_time`, currentTime);
          });
        } else {
          console.warn(
            `Ref ${refKey} is not available or does not have getItemCodeListData method.`
          );
        }
      }
    },
    // itemCode搜索
    itemCodeSuggestionsSearch(itemCode, cb) {
      let list = [];
      this.itemCodeList.forEach((element) => {
        list.push({ value: element.itemCode });
      });
      let results = itemCode ? list.filter(this.createFilter(itemCode)) : list;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !=
            -1 || restaurant.value.indexOf(queryString) != -1
        );
      };
    },
    handleSearch() {
      const productName = this.searchParams.productName;
      const itemCode = this.searchParams.itemCode;
      if (this.dataType == "Spec") {
        this.$refs.specListRef.searchListData(productName, itemCode);
      } else if (this.dataType == "SDS") {
        this.$refs.sdsListRef.searchListData(productName, itemCode);
      }
    },
    handleCoaClick() {
      let language = localStorage.getItem("language");
      this.$router.push({ path: "new-coa",query:{language }});
    },
    handleVerifyListClick() {
      let language = localStorage.getItem("language");
      this.$router.push({
        path: "new-verify-list",
        query: { verifyList:1,language:language },
      });
    },
    userInfo() {},
    handleFileClick() {},
    // 数据类型切换
    dataTypeChange() {
      localStorage.setItem("dataType", this.dataType);
      
      // 同步更新URL参数
      const currentQuery = { ...this.$route.query };
      currentQuery.type = this.dataType.toLowerCase();
      
      // 更新URL但不刷新页面
      this.$router.replace({
        path: this.$route.path,
        query: currentQuery
      });
      
      this.handleSearch();
    },
    multipleSelection() {},
    addToLibrary() {},
  },
};
</script>
